/*
 * @Date: 2021-01-27 11:13:13
 * @Author: lvjun
 * @Description: 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import routerArr from './Router'
import onlineService from './onlineService'
import serviceReport from './serviceReport'
import flyingRabbit from './flyingRabbit'
import qualityControl from './qualityControl'
import qualityTesting from './qualityTesting'
import serviceBI from './serviceBI'

Vue.use(VueRouter)
const Redirect = () => import( /* webpackChunkName: "layout" */ '@/views/layout/Redirect.vue')
const routes = [
  {
    path: '/',
    redirect: '/login',
    component: () => import('@/views/login/Login.vue')
  },
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue')
  },
  {
    path: '/bindWeChat',
    name: 'BindWeChat',
    component: () => import('@/views/login/BindWeChat.vue')
  },
  // 刷新空白页
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('@/views/layout/Layout.vue'),
    children: [{
      path: '/redirect/:path*',
      component: Redirect
    }]
  },
  {
    path: '',
    redirect: '',
    component: () => import('@/views/layout/Layout.vue'),
    children: [
      ...routerArr,
      ...onlineService,
      ...serviceReport,
      ...flyingRabbit,
      ...qualityControl,
      ...qualityTesting,
      ...serviceBI
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: 'outsourced',
  routes
})
const whiteList = ['Login', 'BindWeChat']
router.beforeEach((to, from, next) => {
  if (['Login', 'BindWeChat'].includes(to.name) || store.getters.token) {
    next()
  } else {
    if (to.name !== 'Login') {
      next({
        name: 'Login'
      });
    } else {
      next()
    }
  }
})

export default router
